import * as React from "react";
import "../../views/Staff.scss";

import { cilPencil, cilTrash, cilUser } from "@coreui/icons";
import { Roles } from "../types";
import EditEmergency from "./EditEmergency";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveRolesUser } from "../../redux/reducers/userReducer";
import usePermission from "../../hooks/usePermission";
import { convertUTCtoLocale } from "../../utils/formatConverters";
import moment from "moment";
import EditEmergencyRelation from "./EditEmergencyRelation";
import { FaEye, FaInfoCircle, FaList } from "react-icons/fa";
//service
import { IconButton, Modal, Spinner } from "../Atomics";
import { cilX } from "@coreui/icons";

interface ParentsRowProps {
  parent: Roles;
  removeUser: (id: number) => void;
  refreshParents: () => void;
}


type Item = {
  id: number;
  title: string;
  attachment: string
};

const FwdRowActivities: React.FC<ParentsRowProps> = ({
  parent,
  removeUser,
  refreshParents,
}) => {
  const { checkPermission } = usePermission()
  const dispatch = useDispatch();

  const [visibleEditParent, setVisibleEditParent] = React.useState(false);
  const localeDate = convertUTCtoLocale(parent.createdAt);
  function onPressAdd() {
    setVisibleEditParent(!visibleEditParent);
  }
  const history = useHistory();

  const handleNavigation = (item: any) => {
    history.push('/alert-activity-count', item);
  };



  const [isVisible, setIsVisible] = React.useState(false); // modal ke liye state
  const [item, setItem] = React.useState<Item | null>(null);

  const openModal = () => setIsVisible(true);
  const closeModal = () => setIsVisible(false);

  const handleModal = (item: any) => {
    openModal()
    setItem(item)
  }


  const getAttachmentType = (url: string) => {
    const ext = url.split(".").pop()?.toLowerCase();
    if (!ext) return "unknown";

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
      return "image";
    }
    if (["mp3", "wav", "ogg", "m4a"].includes(ext)) {
      return "audio";
    }
    return "unknown";
  };

  console.log("parent?.group_messages[0]?.type", parent?.group_messages?.[0]?.type);


  return (
    <>

      <div key={parent?.id} className="d-flex py-3 px-3 user-information-container justify-content-around">

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break text-capitalize">
            {parent?.group_messages && (
              <>
                <FaEye onClick={() => handleModal(parent)} className="cursor-pointer" />{" "}
                {parent?.title
                  ? parent.title.length >= 12
                    ? parent.title.substring(0, 13) + "..."
                    : parent.title
                  : parent?.group_messages[0]?.type + " Message"}
              </>
            )}

            {/* Agar group_messages nahi hai to simple title ya message show karo */}
            {!parent?.group_messages && (
              <>
                {parent?.title
                  ? parent.title
                  : parent?.group_messages?.[0]?.type + " Message"}
              </>
            )}
          </p>

        </div>

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break">
            {parent?.notify_type ? parent?.notify_type : parent?.notify_type}
          </p>
        </div>

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break ms-5">
            {parent?.total_student ? parent?.total_student : '-'}
          </p>
        </div>

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break">
            {parent?.acknowledge_count ? parent?.acknowledge_count : 0}
          </p>
        </div>

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break">
            {parent?.createdAt ? moment(parent?.createdAt).fromNow() : '-'}
          </p>
        </div>

        <div className="col d-flex justify-content-start">
          <p className="text-light word-break">
            {parent?.status ? parent?.status : '-'}
          </p>
        </div>

        <div className="col-auto is-hover d-flex justify-content-center">
          <div onClick={() => handleNavigation(parent?.alert_activity_count)} className=" is-hover word-break" style={{ width: "100%" }}>
            <FaList />
          </div>
        </div>
      </div>


      <EditEmergencyRelation
        visible={visibleEditParent}
        closeModal={onPressAdd}
        refreshParents={refreshParents}
        parentData={{
          parentId: parent.id,
          name: parent.name
        }}
      />

      <Modal visible={isVisible}>
        <div className="new-staff-container h-auto">
          <div className="new-staff-header">
            <p className="text-light py-2 ps-4 fs-5">Alerts Log Detail</p>
            <IconButton icon={cilX} className="me-3" onClick={closeModal} />
          </div>

          <div className="py-3 px-3 mt-5" style={{ height: 300, overflowX: "auto" }}>
            {/* <h5>{item?.attachment && getAttachmentType(item.attachment) === "image" && "Image"}</h5>
            <h5>{item?.attachment && getAttachmentType(item.attachment) === "audio" && "Audio Message"}</h5> */}
            <h5>{item?.title && "Impromptu Message"}</h5>
            <p className="break-word">{item?.title}</p>

            {item?.attachment && getAttachmentType(item.attachment) === "image" && (
              <div style={{ marginTop: 10, marginBottom: 10 }}>

                <div className="d-flex align-items-center  ">
                  <div style={{ lineHeight: "90%" }}>
                    <FaInfoCircle color="white" />
                  </div>

                  <p className="ps-2 text-white mb-0" style={{ fontSize: 14, color: "#555", marginBottom: 5 }}>
                    Click to preview image in browser
                  </p>
                </div>
                <a href={item.attachment} target="_blank" rel="noopener noreferrer">
                  <img
                    src={item.attachment}
                    alt="alert"
                    style={{
                      width: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                      cursor: "pointer",
                    }}
                  />
                </a>
              </div>
            )}

            {item?.attachment && getAttachmentType(item.attachment) === "audio" && (
              <audio controls src={item.attachment} style={{ marginTop: 15, width: "100%" }}>
                Your browser does not support the audio element.
              </audio>
            )}
          </div>
        </div>
      </Modal>


    </>
  );
};

export default FwdRowActivities;
